module.exports = __webpack_public_path__ + "d1ffe3bbf385b0a6b31599e69fca09f4.png";